module.exports = __webpack_public_path__ + "public/images/blue-arrow.ddb56aa02748a98e29e2cb0174baff55.svg";